/**
 * Local color palette for the web-views app. This bundle is standalone (it does not share
 * the main app's theme). Extend as more views land.
 *
 * Values are projected onto `:root` as `--<key>` CSS custom properties (see `applyTheme.ts`),
 * so the same palette is usable from `.module.scss` files via `var(--text-main)` and from
 * TS/TSX via `colors['text-main']` (e.g. for SVG `fill`).
 */
export const colors = {
    'color-white': '#ffffff',
    'color-secondary': '#bababa',
    'color-primary': '#121212',
    'accent-color-brand': '#1044FF',
    'background-color-highlighted': 'rgba(255, 255, 255, 0.06)',
} as const;

export type ThemeColor = keyof typeof colors;
